package com.nonopn.skydome.common.app.pages.certificates

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.sharing.createShareManager
import com.nonopn.skywatcher.design.utils.rememberWideColumns
import com.nonopn.skywatcher.design.widgets.abslists.AbstractSectionLists
import eu.codlab.viewmodel.rememberViewModel

@Composable
fun CertificatesScreen(
    currentInterface: ApiInterface
) {
    val model = rememberViewModel { CertificatesModel(currentInterface) }
    val shareManager = remember { createShareManager() }
    val appModel = LocalApp.current

    val columns = rememberWideColumns(max = 4)

    AbstractSectionLists(
        model = model,
        columns = columns,
        renderSectionKey = { it.uuid },
        renderElementKey = { s, e, i -> "${s.uuid}_${i}_${e.hashCode()}" },
        renderSectionTitle = {
            RenderTitle(project = it)
        },
        renderElement = { _, project, detectedActivity ->
            RenderThunderDetectionActivity(
                project = project,
                lightningDetectionActivity = detectedActivity,
                shareManager = shareManager,
                appModel = appModel
            )
        }
    )
}
